'use strict';

module.exports = function getXMLHttpRequest() {
  var progId, progIds, i;

  if (global.XMLHttpRequest) {
    return new global.XMLHttpRequest();
  } else {
    try {
      progIds = ['Msxml2.XMLHTTP', 'Microsoft.XMLHTTP', 'Msxml2.XMLHTTP.4.0'];

      for (i = 0; i < 3; i++) {
        try {
          progId = progIds[i];

          if (new global.ActiveXObject(progId)) {
            break;
          }
        } catch (e) {}
      }

      return new global.ActiveXObject(progId);
    } catch (e) {
      throw new Error('XMLHttpRequest is not supported by your browser');
    }
  }
};